<template>
  <div></div>
</template>

<script>
export default {
  name: 'Logout',
  mounted () {
    this.$http.get('/auth/logout').then(() => {
      window.localStorage.setItem('token', '');
      this.$root.userLoggedIn = false;
      this.$root.showInactivityAlert = false;
      this.$http.defaults.headers.Authorization = 'Bearer none';
      window.localStorage.removeItem('last-token-refresh');
      this.$router.push({ name: 'Login' });
      this.$root.resetProfile();
    }).catch((error) => {
      console.log(error);
      window.localStorage.setItem('token', '');
      this.$root.userLoggedIn = false;
      this.$root.showInactivityAlert = false;
      this.$http.defaults.headers.Authorization = 'Bearer none';
      window.localStorage.removeItem('last-token-refresh');
      this.$router.push({ name: 'Login' });
    });
  }
}
</script>
